import React, { useEffect } from "react";
import { useKeenSlider } from "keen-slider/react";
import { cropImageSize, getAssetsUrl } from "../../../utils/functions";
import "keen-slider/keen-slider.min.css";
import styled from "styled-components";

const storeUrl = getAssetsUrl();

const Wrap = styled.div`
  position: relative;

  .arrow {
    position: absolute;
    top: 50%;
    z-index: 2;
    transform: translate(0, -20px);
  }

  .arrow:not(.arrow--disabled) {
    cursor: pointer;
  }

  .arrow--disabled {
    opacity: 0;
  }

  .arrow--left {
    left: 40px;
  }

  .arrow--right {
    right: 40px;
  }

  .keen-slider {
    align-items: center;
  }

  .lazy__slide {
    height: 50vw;
    background-color: #f7f7f7;
    background-image: url(${storeUrl + "loader.svg"});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: auto;
  }

  @media (min-width: 768px) {
    .lazy__slide {
      height: 300px;
    }
  }

  .lazy__slide img {
    background-color: transparent;
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    -webkit-transform: translateY(-50%) translateX(-50%);
  }
`;

const ModalImagesWrap = styled.div`
  z-index: 1;

  div {
    height: 100%;
    text-align: center;
  }

  img {
    display: block;
    max-width: 100%;
  }
`;

export default (props) => {
  const images = [...props.images];
  const [loaded, setLoaded] = React.useState([]);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [sliderRef, slider] = useKeenSlider({
    afterChange(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
    loop: true,
    initial: 0,
  });

  if (images.length > 1 && typeof images[0] === 'object' && images[0].src) {
    images.shift();
  }

  useEffect(() => {
    const new_loaded = [...loaded];
    new_loaded[currentSlide] = true;
    setLoaded(new_loaded);
  }, [currentSlide]);

  return (
    <Wrap>
      <ModalImagesWrap ref={sliderRef} className="keen-slider">
        {images.map((image, idx) => {
          const imageSrc = typeof image === 'string' ? image : image.src;
          
          return (
            <div key={idx} className="keen-slider__slide lazy__slide">
              <img 
                src={loaded[idx] ? cropImageSize(imageSrc, "800") : ""} 
                loading="lazy" 
                decoding="async" 
                alt="" 
              />
            </div>
          );
        })}
      </ModalImagesWrap>
      {slider && (
        <>
          <ArrowLeft onClick={(e) => e.stopPropagation() || slider.prev()} disabled={currentSlide === 0} />
          <ArrowRight onClick={(e) => e.stopPropagation() || slider.next()} disabled={currentSlide === slider.details().size - 1} />
        </>
      )}
    </Wrap>
  );
};

function ArrowLeft(props) {
  const disabeld = props.disabled ? " arrow--disabled" : "";
  return (
    <svg
      onClick={props.onClick}
      className={"arrow arrow--left" + disabeld}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <defs>
        <filter id="um24owgbla">
          <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.980392 0 0 0 0 0.976471 0 0 0 0 0.964706 0 0 0 1.000000 0" />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" opacity=".348">
        <circle cx="24" cy="24" r="24" fill="#333" />
        <g filter="url(#um24owgbla)">
          <g>
            <path fill="#000" fillRule="nonzero" d="M23.12 11.12L21 9 12 18 21 27 23.12 24.88 16.24 18z" transform="translate(5.25 6)" />
            <path d="M0 0L36 0 36 36 0 36z" transform="translate(5.25 6)" />
          </g>
        </g>
      </g>
    </svg>
  );
}

function ArrowRight(props) {
  const disabeld = props.disabled ? " arrow--disabled" : "";
  return (
    <svg
      onClick={props.onClick}
      className={"arrow arrow--right" + disabeld}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <defs>
        <filter id="6ey9ycviya">
          <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.980392 0 0 0 0 0.976471 0 0 0 0 0.964706 0 0 0 1.000000 0" />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" opacity=".347" transform="rotate(-180 24 24)">
        <circle cx="24" cy="24" r="24" fill="#333" />
        <g filter="url(#6ey9ycviya)">
          <g>
            <path fill="#000" fillRule="nonzero" d="M23.12 11.12L21 9 12 18 21 27 23.12 24.88 16.24 18z" transform="translate(5.25 6)" />
            <path d="M0 0L36 0 36 36 0 36z" transform="translate(5.25 6)" />
          </g>
        </g>
      </g>
    </svg>
  );
}
